<template>
	<div id="visitRecordList">
			<el-form :inline="true" :model="form" label-width="90px" class="clearfix pt-30">
				<div>
					<el-form-item label="拜访时间">
						<ys-daterange-picker v-model="dateValue" type="date" :endDisabledDate="new Date()" />
					</el-form-item>
					<el-form-item label="销售顾问">
						<el-select v-model="form.managerId" filterable clearable placeholder="请选择销售顾问">
							<el-option :label='item.name' :value="item.managerId" v-for='item in managerList' :key='item.managerId'></el-option>
						</el-select>
					</el-form-item>
          <el-button type="info" class="ml-10" @click="search" icon="el-icon-search">搜 索</el-button>
				</div>
			</el-form>
			<div class="clearfix">
				<el-button class="fr mr-30" type="text" @click="exportInfo">批量导出</el-button>
			</div>
			<el-table :data="list" class='mt-10 table-default'>
				<el-table-column label="销售顾问" min-width="100">
					<template slot-scope="{row}">
						<div>{{row.managerName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="拜访时间" min-width="115">
					<template slot-scope="{row}">
						<div>
              <span>{{row.startDate}}</span>
              <span>至</span>
              <span>{{row.endDate}}</span>
            </div>
					</template>
				</el-table-column>
				<el-table-column label="拜访客户数" sortable min-width="115" prop="visitCustomerTimes"></el-table-column>
				<el-table-column label="拜访时长" sortable min-width="90" prop="visitDurationMinutes">
					<template slot-scope="{row}">
						<div v-if="row.visitDurationMinutes">{{row.visitDurationText}}</div>
						<div v-else>暂无数据</div>
					</template>
				</el-table-column>
			</el-table>
	</div>
</template>

<script>
	import { axiosApi, basePath } from '~/api/api'
	import { getManagerInfo, getStatistics } from "~/api/sales";
	import { computeNumber, postExcelFile, parseTime,getDateSixMonthsBefore } from "@/utils";
  import { mapActions, mapMutations } from "vuex";

	export default {
		components: {},
		data() {
			return {
				form:{
          startTime: null,
          endTime:null,
          managerId: null,
        },
        dateValue:[getDateSixMonthsBefore(1),new Date()],
				managerList:[],
        list:[],
			}
		},
    watch:{
      dateValue:{
        handler: function(val) {
          this.form.startTime = val[0] ?  parseTime(val[0], '{y}-{m}-{d}') : null
          this.form.endTime = val[1] ? parseTime(val[1], '{y}-{m}-{d}')  : null
        },
        deep: true,
        immediate:true
      },
    },
		methods: {
			getSelectionList(){
				this.getManagerList()
			},
			getManagerList(){
				getManagerInfo({sellerId:sessionStorage.traderId}).then(res=>{
					this.managerList = res.elements
				}).catch(err=>{

				})
			},
			search() { //提交
        this.currentPage = 1
        this.getList()
			},

      getList(){
        getStatistics(this.form).then(res=>{
					var list = res.map(item=>{
						item.startDate = item.startTime?parseTime(item.startTime, '{y}-{m}-{d}') :''
						item.endDate = item.endTime?parseTime(item.endTime, '{y}-{m}-{d}') :''
						return item
					})
					console.log(list,'xx')
          this.list = list
        }).catch(err=>{

        })
      },
			exportInfo(){
				let body =  {}
					body = Object.assign({},this.form)
					body.modelName = 'empty',
					body.startRow = 0
					body.fileName = '拜访统计.xls'
					postExcelFile(body,'/sunrise-gateway/export/sales/visitSign/statistics')
			},
		},
		activated() {
			this.$nextTick(() => {
				this.getSelectionList()
				this.search()
			})
		},
		computed: {
		
		},
		mounted(){
			this.getSelectionList();
			this.search()
		}
	}
</script>

<style lang="less">
	#visitRecordList {
		.border {
			border: 1px solid #EEEEEE;
			background-color: #EEEEEE;
		}
		.inputWidth {
			width: 170px;
		}
	}
</style>